module.exports = __webpack_public_path__ + "static/media/tool-card-4-icon.1e9c3b2c.svg";